/* eslint-disable import/prefer-default-export */

import { API_URL } from '../../../../../../../utils/config';

export const PTP_VLAN_IP_URL = `${API_URL}/ptpvlan`;
